import Flickity from "flickity";

const ImageTextTwoColSlider = (slides) => {

    var slider = new Flickity(slides, {
        adaptiveHeight: false,
        cellAlign: 'left',
        contain: false,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true
    });

}

export default ImageTextTwoColSlider;